import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material';
import { PAGE_LIST } from 'constant/pages';
import { useNavigate } from 'react-router-dom';
import { removeKeyFromLocalStorage } from 'utils/constant';
import ja from 'utils/ja';

interface SettingDBProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const SettingDBDialog: React.FC<SettingDBProps> = ({ open, setOpen }) => {
  const navigate = useNavigate();
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          maxWidth: '833px',
          width: '100%',
          height: 'auto',
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '45px',
          padding: '20px',
        }}
      >
        {ja.setting.db_setting}
        <Divider />
      </DialogTitle>

      <DialogContent
        sx={{ textAlign: 'center', fontSize: '40px', padding: '20px 10px' }}
      >
        {ja.setting.db_setting_contents}
      </DialogContent>
      <DialogActions
        sx={{ height: '100%', maxHeight: '60px', padding: '20px' }}
      >
        <Button onClick={() => setOpen(false)} sx={{ fontSize: '40px' }}>
          {ja.setting.cancel}
        </Button>
        <Button
          onClick={() => {
            removeKeyFromLocalStorage([
              'appId',
              'appKey',
              'dbId',
              'dbKey',
              'url',
            ]);
            navigate(PAGE_LIST.SETTING.pathname());
          }}
          sx={{ fontSize: '40px' }}
        >
          {ja.setting.OK}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default SettingDBDialog;
